module.exports = __webpack_public_path__ + "static/fonts/OPPOSans-M.8a567f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Font-OPPOSans/OPPOSans-M.ttf
// module id = 7f9A
// module chunks = 26